import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromoDetailsClickAction } from '../../actions/analytics';
import { openPromoDetails } from '../../actions/promoDetails';
import { PromoItem } from '../../components/PromoItem';
import { selectIsBestMortgageOffersPage } from '../../selectors/page';
import { selectPromoById } from '../../selectors/promos/promos';
import { TThunkDispatch } from '../../types/redux/thunk';
import { trackBestMortgageOffersTrapShow } from '../../utils/analytics/trackBestMortgageOffersTrapShow';

interface IPromoItemContainerProps {
  promoId: string;
}

export const PromoItemContainer = ({ promoId }: IPromoItemContainerProps) => {
  const promo = useSelector(selectPromoById(promoId));
  const isBestMortgageOffersPage = useSelector(selectIsBestMortgageOffersPage);
  const dispatch: TThunkDispatch = useDispatch();

  const cardRef = React.useRef<HTMLElement>(null);
  const bannerImpressionSent = React.useRef(false);

  React.useEffect(() => {
    if (!isBestMortgageOffersPage || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const node = cardRef.current;
    if (!node) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !bannerImpressionSent.current) {
          bannerImpressionSent.current = true;
          trackBestMortgageOffersTrapShow({
            kind: 'banner',
            bankName: promo.providerName,
            bankProgram: promo.promoName,
          });
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [isBestMortgageOffersPage, promo.promoName, promo.providerName]);

  const openPromoDetailsModal = React.useCallback(() => {
    dispatch(openPromoDetails(promoId));
    if (!isBestMortgageOffersPage) {
      dispatch(trackPromoDetailsClickAction(promoId));
    }
  }, [dispatch, promoId, isBestMortgageOffersPage]);

  return <PromoItem ref={cardRef} promo={promo} onClick={openPromoDetailsModal} promoId={promoId} />;
};
